/*
    Below are some examples of how to configure dependency versions.
    Occasionally there will be times when a web app needs to use a non-latest version
    of a runtime dependency, whether it is a 3rd party or an in-house Climate owned library
    or application. In some cases the web app is incompatible with the latest version
    of a dependency due to a breaking change and requires an older version.
    Another situation, is when an new feature in a Climate dependency hasn't been
    released--possibly due to a non-CDep release schedule--but is available as a canary
    release in which case 'isExp' added to the object and set to true.
    If you find yourself configuring depVersions it is best practice to make a comment
    to explain the purpose of usage and/or create a followup ticket to indicate the
    the appropriate time to remove it.
*/
window.depVersions = {
  /*
     'tcc-i18n': {
       'version': 'fe318e7',
       'main': 'i18n.js'
     },
     'tcc-crate': {
       'version': '0cdc633',
       'main': 'tcc-crate.js',
       'isExp': true
     },
     'react': {
       'version': 'c813d07',
       'main': 'react.js'
     },
     'react-dom': {
       'version': '0945954',
       'main': 'react-dom.min.js'
     } */
};
